exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes fadein-to-left {\n  0% {\n    -webkit-transform: translate(20%);\n            transform: translate(20%);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translate(0%);\n            transform: translate(0%);\n    opacity: 1;\n  }\n}\n@keyframes fadein-to-left {\n  0% {\n    -webkit-transform: translate(20%);\n            transform: translate(20%);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translate(0%);\n            transform: translate(0%);\n    opacity: 1;\n  }\n}\n.animate--fadein-to-left {\n  -webkit-animation: fadein-to-left 1.2s cubic-bezier(0.29, 0.99, 0.58, 1) forwards;\n          animation: fadein-to-left 1.2s cubic-bezier(0.29, 0.99, 0.58, 1) forwards;\n  opacity: 0;\n}\n.animate--fadein-to-left:nth-child(1) {\n  -webkit-animation-delay: .2s;\n          animation-delay: .2s;\n}\n.animate--fadein-to-left:nth-child(2) {\n  -webkit-animation-delay: .4s;\n          animation-delay: .4s;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/davidlagace/Sites/david-lagace-website/src/app/about/about.component.less
// module id = ../../../../../src/app/about/about.component.less
// module chunks = main